module.exports = __webpack_public_path__ + "static/media/star.ffa51caf.gif";